var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_3117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.724609,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_3117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7243 16.5001L19.0576 13.1667L17.891 12.0001L16.5576 13.3334V9.85425H14.891V13.3334L13.5576 12.0001L12.391 13.1667L15.7243 16.5001ZM12.391 19.0001V17.3334H19.0576V19.0001H12.391ZM5.72428 15.6667C5.26595 15.6667 4.87359 15.5036 4.5472 15.1772C4.22081 14.8508 4.05762 14.4584 4.05762 14.0001V2.33341C4.05762 1.87508 4.22081 1.48272 4.5472 1.15633C4.87359 0.829943 5.26595 0.666748 5.72428 0.666748H11.5576L16.5576 5.66675V8.18758H14.891V6.50008H10.7243V2.33341H5.72428V14.0001H10.7243V15.6667H5.72428Z",
    fill: "#111827"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSave);
export default __webpack_public_path__ + "static/media/file_save.d51b9cdf4d92c49a61d199125fdeffbb.svg";
export { ForwardRef as ReactComponent };